import { render, staticRenderFns } from "./visual-intercom.vue?vue&type=template&id=1926c84c&scoped=true"
import script from "./visual-intercom.vue?vue&type=script&lang=js"
export * from "./visual-intercom.vue?vue&type=script&lang=js"
import style0 from "./visual-intercom.vue?vue&type=style&index=0&id=1926c84c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926c84c",
  null
  
)

export default component.exports